<template>
  <div>
    <div class="fixed">
      <!-- 筛选框 -->
      <div class="filter-date">
        <div class="filter-left">
          <div class="date" @click="showYm = true">
            {{ queryParam.ym | date('MM月 YYYY') }} <img src="/arrow_down.png" />
          </div>
          <div class="appeal" v-if="windowInfo.isWindowPeriod">
            <div>填写截止至：{{ windowInfo.fillInEndTime }}</div>
            <div>填写版本：{{ windowInfo.ym }} {{ windowInfo.version }}</div>
          </div>
          <div class="appeal" v-else>
            <div>不在窗口期</div>
          </div>
        </div>
        <div class="filter-right">
          <div class="filter filter-non" @click="showCopy = true" v-if="windowInfo.isWindowPeriod">
            <img src="/estimate_copy.png" />
          </div>
          <div :class="{ filter: true, 'filter-non': !isFilter, 'filter-active': isFilter }" @click="showFilter = true">
            <img src="/filter.png" v-if="!isFilter" />
            <img src="/filter_active.png" v-else />
          </div>
        </div>
      </div>
    </div>
    <!-- 列表 -->
    <div class="list">
      <!-- 卡片信息 -->
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="detailList.length == 0 ? '暂无数据' : '没有更多了'"
          @load="onLoad"
        >
          <div class="info" v-for="(item, index) in detailList" :key="index">
            <!-- 标题 -->
            <div class="info-title">
              <div class="content">{{ item.customerAgentName }}</div>
            </div>
            <!-- 信息类型 -->
            <div class="info-type">
              <div class="num">{{ item.productName }}</div>
            </div>
            <!-- 内容信息 -->
            <div class="info-content">
              <div class="info-data">
                <div>F1(原始)</div>
                <div>{{ item.f1 | numberFormat(false) }}</div>
              </div>
              <div class="info-data">
                <div>DDI数量(原始)</div>
                <div>{{ item.mtdOriginNum | numberFormat(false) }}</div>
              </div>
              <div class="info-data">
                <div>F2(原始)</div>
                <div>{{ item.f2 | numberFormat(false) }}</div>
              </div>
              <div class="info-data">
                <div>指标数量</div>
                <div>{{ item.target | numberFormat(false) }}</div>
              </div>
              <div class="info-data">
                <div>Landing(原始)</div>
                <div>{{ item.landing | numberFormat(false) }}</div>
              </div>
            </div>
            <!-- 查看详情 -->
            <div class="info-bottom">
              <div>{{ item.mrName }}</div>
              <div class="info-appeal" v-if="windowInfo.isWindowPeriod && item.canEdit == 0">
                <template v-if="item[windowInfo.version.toLowerCase()] && item[windowInfo.version.toLowerCase()] > 0">
                  <div class="appeal-tips">已填写</div>
                  <div class="appeal appeal-modify" @click="handleEdit(item, 'edit')">修改 ></div>
                </template>
                <template v-else>
                  <div class="appeal-tips">未填写</div>
                  <div class="appeal appeal-edit" @click="handleEdit(item, 'edit')">填写 ></div>
                </template>
              </div>
              <div class="detail" @click="handleEdit(item, 'view')" data-sensors-click v-else>查看详情 ></div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      <div class="total">
        <div class="total-item">
          <div>总条数：</div>
          <div>{{ detailInfo.total }}</div>
        </div>
        <div class="total-item">
          <div>F1(标准)：</div>
          <div>{{ summaryInfo.f1 | numberFormat(false) }}</div>
        </div>
        <div class="total-item">
          <div>F2(标准)：</div>
          <div>{{ summaryInfo.f2 | numberFormat(false) }}</div>
        </div>
        <div class="total-item">
          <div>Landing(标准)：</div>
          <div>{{ summaryInfo.landing | numberFormat(false) }}</div>
        </div>
      </div>
    </div>
    <van-popup v-model="showFilter" round position="bottom" get-container="#app" :style="{ height: '80%' }">
      <div class="filter-title">筛选<img src="/filter_close.png" @click="showFilter = false" /></div>
      <div class="filter-box">
        <!-- 筛选框 -->
        <van-form>
          <van-row>
            <van-col span="24" class="input-title">目标医院</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="customerAgentName"
                placeholder="请选择目标医院"
                @click="showCustomerAgent = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="customerAgentId" @click.stop="clearSelect('customerAgentId')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">Brand Group</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="brandGroup"
                placeholder="请选择Brand Group"
                @click="showBrandGroup = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="brandGroup" @click.stop="clearSelect('brandGroup')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">品牌</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="productLineName"
                placeholder="请选择品牌"
                @click="showProductLine = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="productLineId" @click.stop="clearSelect('productLineId')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">Sales Group</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="cnName"
                placeholder="请选择Sales Group"
                @click="showSalesGroup = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="cnName" @click.stop="clearSelect('cnName')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">NSD</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="nsdName"
                placeholder="请选择NSD"
                @click="showNsd = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="ahTerritoryId" @click.stop="clearSelect('ahTerritoryId')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">RM</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="rmName"
                placeholder="请选择RM"
                @click="showRm = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="rmTerritoryId" @click.stop="clearSelect('rmTerritoryId')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">DM</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="dmName"
                placeholder="请选择DM"
                @click="showDm = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="dmTerritoryId" @click.stop="clearSelect('dmTerritoryId')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">MR</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="mrName"
                placeholder="请选择MR"
                @click="showMr = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="mrTerritoryId" @click.stop="clearSelect('mrTerritoryId')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
          </van-row>

          <div class="filter-btn">
            <van-button class="btn" round block @click="reset">重置</van-button>
            <van-button class="btn" round block type="info" @click="search">应用</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
    <!-- YM选择框 -->
    <van-popup v-model="showYm" round position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        @confirm="confirmDate"
        @cancel="showYm = false"
      />
    </van-popup>
    <!-- 目标医院 -->
    <van-popup v-model="showCustomerAgent" position="bottom">
      <van-search v-model="customerAgentValue" @input="searchCustomerAgent" placeholder="搜索目标医院" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="customerAgentResultList"
        value-key="customer_agent_name"
        @confirm="confirmCustomerAgent"
        @cancel="showCustomerAgent = false"
      />
    </van-popup>
    <!-- Brand Group -->
    <van-popup v-model="showBrandGroup" position="bottom">
      <van-search v-model="brandGroupValue" @input="searchBrandGroup" placeholder="搜索Brand Group" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="brandGroupResultList"
        value-key="brandGroup"
        @confirm="confirmBrandGroup"
        @cancel="showBrandGroup = false"
      />
    </van-popup>
    <!-- 品牌 -->
    <van-popup v-model="showProductLine" position="bottom">
      <van-search v-model="productLineValue" @input="searchProductLine" placeholder="搜索品牌" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="productLineResultList"
        value-key="product_line_name"
        @confirm="confirmProductLine"
        @cancel="showProductLine = false"
      />
    </van-popup>
    <!-- Sales Group -->
    <van-popup v-model="showSalesGroup" position="bottom">
      <van-search v-model="salesGroupValue" @input="searchSalesGroup" placeholder="搜索Sales Group" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="salesGroupResultList"
        @confirm="confirmSalesGroup"
        @cancel="showSalesGroup = false"
      />
    </van-popup>
    <!-- NSD -->
    <van-popup v-model="showNsd" position="bottom">
      <van-search v-model="nsdValue" @input="searchNsd" placeholder="搜索NSD" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="nsdList"
        value-key="dsm_user_name"
        @confirm="confirmNsd"
        @cancel="showNsd = false"
      />
    </van-popup>
    <!-- RM -->
    <van-popup v-model="showRm" position="bottom">
      <van-search v-model="rmValue" @input="searchRm" placeholder="搜索RM" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="rmList"
        value-key="asm_user_name"
        @confirm="confirmRm"
        @cancel="showRm = false"
      />
    </van-popup>
    <!-- DM -->
    <van-popup v-model="showDm" position="bottom">
      <van-search v-model="dmValue" @input="searchDm" placeholder="搜索DM" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="dmList"
        value-key="dsm_user_name"
        @confirm="confirmDm"
        @cancel="showDm = false"
      />
    </van-popup>
    <!-- MR -->
    <van-popup v-model="showMr" position="bottom">
      <van-search v-model="mrValue" @input="searchMr" placeholder="搜索MR" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="mrList"
        value-key="mr_user_name"
        @confirm="confirmMr"
        @cancel="showMr = false"
      />
    </van-popup>
    <!-- 复制弹框 -->
    <van-popup v-model="showCopy" position="bottom" :style="{ height: '160px' }">
      <van-cell-group>
        <van-cell title="全部复制指标数量" is-link @click="copyNum('target')">
          <template #right-icon></template>
        </van-cell>
        <van-cell title="全部复制上次预估数量" is-link @click="copyAll">
          <template #right-icon></template>
        </van-cell>
        <van-cell title="全部复制DDI数量(原始)" is-link @click="copyNum('ddi')">
          <template #right-icon></template>
        </van-cell>
      </van-cell-group>
    </van-popup>
    <!-- 全部复制上次预估数量弹框 -->
    <van-dialog
      v-model="showCopyAll"
      show-cancel-button
      :show-confirm-button="canCopy"
      @cancel="showCopyAll = false"
      @confirm="handelCopyAll"
    >
      <template #default>
        <div class="all-copy" v-if="canCopy">
          <p>复制数量会覆盖您或您下属当前已输入的数量，且无法撤回</p>
          <p>确定全部复制{{ recentWindows.estimateYm + ' ' + recentWindows.version }}吗?</p>
        </div>
        <div class="all-copy" v-else>
          <p>当前页面有多个Franchise，不支持全部复制</p>
        </div>
      </template>
    </van-dialog>
    <EditOrView ref="editOrView" @success="success" />
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import _ from 'lodash'
import moment from 'moment'
import EditOrView from './EditOrView.vue'
export default {
  components: {
    EditOrView,
  },
  data() {
    return {
      loading: false,
      refreshing: false,
      finished: false,
      showFilter: false, // 筛选框
      showYm: false, // YM选择
      showCustomerAgent: false, // 显示目标医院
      showProductLine: false, // 显示品牌
      showSalesGroup: false, // 显示Sales Group
      showBrandGroup: false, // 显示Brand Group
      showNsd: false, // 显示NSD
      showRm: false, // 显示Rm
      showDm: false, // 显示Dm
      showMr: false, // 显示MR
      showCopy: false, // 显示复制弹框
      showCopyAll: false, // 显示全部复制上次预估数量弹框
      isFilter: false, // 是否进行过搜索
      currentDate: new Date(),
      pageNo: 1, // 分页
      windowInfo: {}, // 窗口信息
      summaryInfo: {}, // 填写汇总
      detailInfo: {}, // 详情列表信息
      detailList: [], // 详情列表
      queryParam: {
        ym: '',
      },
      customerAgentId: null, // 目标医院
      customerAgentName: null, // 目标医院名称
      customerAgentValue: '', // 目标医院搜索内容
      customerAgentList: [], // 目标医院列表
      customerAgentResultList: [], // 目标医院搜索结果列表
      productLineId: null, // 品牌
      productLineName: null, // 品牌名称
      productLineValue: '', // 品牌搜索内容
      productLineList: [], // 品牌列表
      productLineResultList: [], // 品牌搜索结果列表
      cnName: null, // Sales Group名称
      salesGroupValue: '', // Sales Group搜索内容
      salesGroupList: [], // Sales Group列表
      salesGroupResultList: [], // Sales Group搜索结果列表
      brandGroup: null, // Brand Group名称
      brandGroupValue: '', // Brand Group搜索内容
      brandGroupList: [], // Brand Group列表
      brandGroupResultList: [], // Brand Group搜索结果列表
      ahTerritoryId: null, // NSD
      nsdName: null, // NSD名称
      nsdValue: '', // NSD搜索内容
      nsdList: [], // NSD列表
      rmTerritoryId: null, // RM
      rmName: null, // RM名称
      rmValue: '', // RM搜索内容
      rmList: [], // RM列表
      dmTerritoryId: null, // DM
      dmName: null, // DM名称
      dmValue: '', // DM搜索内容
      dmList: [], // DM列表
      mrTerritoryId: null, // MR
      mrName: null, // MR名称
      mrValue: '', // MR搜索内容
      mrList: [], // MR列表
      canCopy: true, // 是否支持全部复制
      recentWindows: {}, // 需要复制的预估版本信息
    }
  },
  watch: {
    'queryParam.ym': {
      handler: function (val) {
        this.pageNo = 1
        // 清空列表数据
        this.finished = false
        // 重新加载数据
        this.loading = true
        this.detailList = []
        this.detailInfo = {}
        this.summaryInfo = {}
        this.getWindowInfo()
        this.getSummary()
        this.getDetailList()
        this.getCustomerAgent()
        this.getProductLine()
        this.getSalesGroup()
        this.getBrandGroup()
        this.getNsd()
        this.getRm()
        this.getDm()
        this.getMr()
      },
      deep: true, //深度侦听
    },
  },
  mounted() {
    this.getCustomerAgent()
    this.getProductLine()
    this.getSalesGroup()
    this.getBrandGroup()
    this.getNsd()
    this.getRm()
    this.getDm()
    this.getMr()
  },
  methods: {
    // 查看详情
    handleEdit(record, type) {
      if (record.isSupplementData && type === 'edit') {
        this.$toast('该适应症为用户非目标适应症，禁止提交填写')
        return
      }
      this.$refs.editOrView.edit(record, type, this.windowInfo)
    },
    // 填写成功回显
    success() {
      // this.search()
    },
    // 获取查看详情信息
    getViewDetail(record) {
      this.queryParam.ym = String(record.ym)
    },

    // 选择YM
    confirmDate(val) {
      this.queryParam.ym = moment(val).format('YYYYMM')
      this.showYm = false
    },
    // 清空下拉框
    clearSelect(select) {
      if (select === 'customerAgentId') {
        this.customerAgentId = null
        this.customerAgentName = null
      } else if (select === 'productLineId') {
        this.productLineId = null
        this.productLineName = null
      } else if (select === 'cnName') {
        this.cnName = null
      } else if (select === 'brandGroup') {
        this.brandGroup = null
      } else if (select === 'ahTerritoryId') {
        this.ahTerritoryId = null
        this.nsdName = null
      } else if (select === 'rmTerritoryId') {
        this.rmTerritoryId = null
        this.rmName = null
      } else if (select === 'dmTerritoryId') {
        this.dmTerritoryId = null
        this.dmName = null
      } else if (select === 'mrTerritoryId') {
        this.mrTerritoryId = null
        this.mrName = null
      }
    },

    // 选择目标医院
    confirmCustomerAgent(val) {
      console.log('选择目标医院------', val)
      this.customerAgentId = val.customer_agent_id
      this.customerAgentName = val.customer_agent_name
      this.showCustomerAgent = false
    },
    // 选择品牌
    confirmProductLine(val) {
      console.log('选择品牌------', val)
      this.productLineId = val.product_line_id
      this.productLineName = val.product_line_name
      this.showProductLine = false
    },
    // 选择Sales Group
    confirmSalesGroup(val) {
      console.log('选择Sales Group------', val)
      this.cnName = val
      this.showSalesGroup = false
    },
    // 选择Brand Group
    confirmBrandGroup(val) {
      console.log('选择Brand Group------', val)
      this.brandGroup = val.brandGroup
      this.showBrandGroup = false
    },
    // 选择NSD
    confirmNsd(val) {
      console.log('选择NSD------', val)
      this.ahTerritoryId = val.ah_territory_id
      this.nsdName = val.dsm_user_name
      this.showNsd = false
    },
    // 选择RM
    confirmRm(val) {
      console.log('选择RM------', val)
      this.rmTerritoryId = val.asm_territory_id
      this.rmName = val.asm_user_name
      this.showRm = false
    },
    // 选择DM
    confirmDm(val) {
      console.log('选择DM------', val)
      this.dmTerritoryId = val.dsm_territory_id
      this.dmName = val.dsm_user_name
      this.showDm = false
    },
    // 选择MR
    confirmMr(val) {
      console.log('选择DM------', val)
      this.mrTerritoryId = val.mr_territory_id
      this.mrName = val.mr_user_name
      this.showMr = false
    },

    // 搜索目标医院
    searchCustomerAgent: _.debounce(function (val) {
      if (val) {
        this.getCustomerAgent(val)
      }
    }, 500),
    // 搜索品牌
    searchProductLine: _.debounce(function (val) {
      const keyword = val.toLowerCase()
      this.productLineResultList = this.productLineList.filter(item =>
        item.product_line_name.toLowerCase().includes(keyword),
      )
    }, 500),
    // 搜索Sales Group
    searchSalesGroup: _.debounce(function (val) {
      const keyword = val.toLowerCase()
      this.salesGroupResultList = this.salesGroupList.filter(item => item.toLowerCase().includes(keyword))
    }, 500),
    // 搜索Brand Group
    searchBrandGroup: _.debounce(function (val) {
      const keyword = val.toLowerCase()
      this.brandGroupResultList = this.brandGroupList.filter(item => item.brandGroup.toLowerCase().includes(keyword))
    }, 500),
    // 搜索NSD
    searchNsd: _.debounce(function (val) {
      if (val) {
        this.getNsd(val)
      }
    }, 500),
    // 搜索RM
    searchRm: _.debounce(function (val) {
      if (val) {
        this.getRm(val)
      }
    }, 500),
    // 搜索DM
    searchDm: _.debounce(function (val) {
      if (val) {
        this.getDm(val)
      }
    }, 500),
    // 搜索MR
    searchMr: _.debounce(function (val) {
      if (val) {
        this.getMr(val)
      }
    }, 500),

    // 获取目标医院下拉框
    getCustomerAgent(customerAgent) {
      getAction('/sip/estimate/detail/getCustomerAgent', {
        ym: this.queryParam.ym,
        customerAgent,
      }).then(res => {
        console.log('获取目标医院数据------', res)
        this.customerAgentList = res.result
        this.customerAgentResultList = [...this.customerAgentList]
      })
    },
    // 获取品牌下拉框
    getProductLine() {
      getAction('/sip/estimate/detail/getProductLine', {
        ym: this.queryParam.ym,
      }).then(res => {
        console.log('获取品牌数据------', res)
        this.productLineList = res.result
        this.productLineResultList = [...this.productLineList]
      })
    },

    // 获取Sales Group下拉框
    getSalesGroup() {
      getAction('/sip/estimate/detail/salesGroup', {
        ym: this.queryParam.ym,
      }).then(res => {
        console.log('获取Sales Group数据------', res)
        this.salesGroupList = res.result
        this.salesGroupResultList = [...this.salesGroupList]
      })
    },
    // 获取Brand Group下拉框
    getBrandGroup() {
      getAction('/sip/estimate/overview/getBrandGroupByYm', {
        ym: this.queryParam.ym,
      }).then(res => {
        console.log('获取Brand Group数据------', res)
        this.brandGroupList = res.result
        this.brandGroupResultList = [...this.brandGroupList]
      })
    },
    // 获取NSD下拉框
    getNsd(ah = null) {
      getAction('/sip/estimate/detail/getAh', {
        ah,
        ym: this.queryParam.ym,
      }).then(res => {
        console.log('获取NSD数据------', res)
        this.nsdList = res.result
      })
    },
    // 获取RM下拉框
    getRm(rm = null) {
      getAction('/sip/estimate/detail/getRM', {
        rm,
        ym: this.queryParam.ym,
      }).then(res => {
        console.log('获取RM数据------', res)
        this.rmList = res.result
      })
    },
    // 获取DM下拉框
    getDm(dm = null) {
      getAction('/sip/estimate/detail/getDM', {
        dm,
        ym: this.queryParam.ym,
      }).then(res => {
        console.log('获取DM数据------', res)
        this.dmList = res.result
      })
    },
    // 获取MR下拉框
    getMr(mr = null) {
      getAction('/sip/estimate/detail/getMR', {
        mr,
        ym: this.queryParam.ym,
      }).then(res => {
        console.log('获取MR数据------', res)
        this.mrList = res.result
      })
    },
    // 获取窗口信息
    getWindowInfo() {
      getAction('/sip/estimate/overview/mobile/getWindowInfoByYm', { ym: this.queryParam.ym }).then(res => {
        console.log('获取窗口信息------', res)
        this.windowInfo = res.result
      })
    },
    // 获取填写汇总
    getSummary() {
      let params = {
        ...this.queryParam,
        customerAgentId: this.customerAgentId,
        brandGroup: this.brandGroup,
        productLineId: this.productLineId,
        cnName: this.cnName,
        ahTerritoryId: this.ahTerritoryId,
        rmTerritoryId: this.rmTerritoryId,
        dmTerritoryId: this.dmTerritoryId,
        mrTerritoryId: this.mrTerritoryId,
      }

      postAction('/sip/estimate/detail/sum', params).then(res => {
        console.log('获取填写汇总------', res)
        if (res.result) {
          this.summaryInfo = res.result
        }
      })
    },
    // 获取详情列表
    getDetailList() {
      let params = {
        ...this.queryParam,
        customerAgentId: this.customerAgentId,
        brandGroup: this.brandGroup,
        productLineId: this.productLineId,
        cnName: this.cnName,
        ahTerritoryId: this.ahTerritoryId,
        rmTerritoryId: this.rmTerritoryId,
        dmTerritoryId: this.dmTerritoryId,
        mrTerritoryId: this.mrTerritoryId,
      }
      postAction(`/sip/estimate/detail/list?pageNo=${this.pageNo}`, params).then(res => {
        console.log('获取详情列表------', res)
        if (res.success) {
          this.detailInfo = res.result
          this.detailList = [...this.detailList, ...res.result.records]
          this.loading = false
          this.pageNo++
          if (res.result.records.length == 0) {
            this.finished = true
          }
          this.refreshing = false
        } else {
          this.loading = false
          this.$toast(res.message)
        }
      })
    },

    // 查询
    search() {
      this.pageNo = 1
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      this.loading = true
      this.detailList = []
      this.queryParam.ym = moment().format('YYYYMM')
      this.getWindowInfo()
      this.getSummary()
      this.getDetailList()
      this.showFilter = false
      if (
        this.customerAgentId ||
        this.productLineId ||
        this.cnName ||
        this.brandGroup ||
        this.ahTerritoryId ||
        this.rmTerritoryId ||
        this.dmTerritoryId ||
        this.mrTerritoryId
      ) {
        this.isFilter = true
      } else {
        this.isFilter = false
      }
      // Vue.ls.set('queryParam', this.queryParam)
      // Vue.ls.set('filterDate', this.filterDate)
    },
    // 重置
    reset() {
      // this.queryParam = {}
      this.customerAgentId = null
      this.customerAgentName = null
      this.productLineId = null
      this.productLineName = null
      this.cnName = null
      this.brandGroup = null
      this.ahTerritoryId = null
      this.nsdName = null
      this.rmTerritoryId = null
      this.rmName = null
      this.dmTerritoryId = null
      this.dmName = null
      this.mrTerritoryId = null
      this.mrName = null
      // Vue.ls.remove('queryParam')
      this.isFilter = false
      this.pageNo = 1
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      this.loading = true
      this.detailList = []
      this.getWindowInfo()
      this.getSummary()
      this.getDetailList()
    },
    onLoad() {
      this.getWindowInfo()
      this.getSummary()
      this.getDetailList()
      // setTimeout(() => {
      // 加载状态结束
      // this.loading = false
      // 数据全部加载完成
      // this.finished = true
      // }, 1000)
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      this.loading = true
      this.search()
    },
    // 全部复制指标数量
    copyNum(type) {
      let that = this
      let request
      if (type === 'target') {
        request = '/sip/estimate/detail/copyTarget'
      } else {
        request = '/sip/estimate/detail/copyDdi'
      }
      let params = {
        ...this.queryParam,
        customerAgentId: this.customerAgentId,
        brandGroup: this.brandGroup,
        productLineId: this.productLineId,
        cnName: this.cnName,
        ahTerritoryId: this.ahTerritoryId,
        rmTerritoryId: this.rmTerritoryId,
        dmTerritoryId: this.dmTerritoryId,
        mrTerritoryId: this.mrTerritoryId,
        estimateTimeId: this.windowInfo.estimateWindowId,
      }
      this.$dialog
        .confirm({
          message: '复制数量会覆盖您或您下属当前已输入的数量，且无法撤回，确定全部复制吗？',
        })
        .then(() => {
          postAction(request, params).then(res => {
            if (res.success) {
              that.$toast(`复制成功,本次复制${res.result}条`)
              that.search()
              that.getSummary()
            } else {
              that.$message.warning(res.message)
            }
            that.showCopy = false
          })
        })
        .catch(() => {})
    },
    // 全部复制上次预估数量
    copyAll() {
      this.getRecentWindows(this.queryParam.ym, true)
    },
    // 获取需要复制的预估版本
    getRecentWindows(ym, open) {
      postAction(`/sip/estimate/detail/getRecentWindows?ym=${ym}`).then(res => {
        console.log('获取需要复制的预估版本------', res)
        if (res.success) {
          this.recentWindows = res.result
          this.canCopy = true
          if (open) {
            this.showCopyAll = true
          }
        } else {
          // this.$message.warning(res.message)
          if (open) {
            this.showCopyAll = true
          }
          this.canCopy = false
        }
      })
    },
    // 全部复制上次预估数量确认
    handelCopyAll() {
      let that = this
      const params = {
        ...this.queryParam,
        customerAgentId: this.customerAgentId,
        brandGroup: this.brandGroup,
        productLineId: this.productLineId,
        cnName: this.cnName,
        ahTerritoryId: this.ahTerritoryId,
        rmTerritoryId: this.rmTerritoryId,
        dmTerritoryId: this.dmTerritoryId,
        mrTerritoryId: this.mrTerritoryId,
        estimateTimeId: this.windowInfo.estimateWindowId,
      }
      if (JSON.stringify(this.recentWindows) === '{}') {
        this.showCopyAll = false
      } else {
        postAction(
          `/sip/estimate/detail/copyLastEstimate?ym=${this.recentWindows.estimateYm}&version=${this.recentWindows.version}`,
          params,
        ).then(res => {
          if (res.success) {
            that.$toast(`复制成功,本次复制${res.result}条`)
            that.search()
            that.getSummary()
            that.showCopyAll = false
            that.showCopy = false
          } else {
            that.$toast(res.message)
            that.showCopyAll = false
            that.showCopy = false
          }
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.van-cell__title {
  text-align: center;
}
.all-copy {
  font-size: 14px;
  color: #000;
  text-align: center;
  padding: 27px 25px;
}
.fixed {
  width: 100%;
  position: fixed;
  min-height: 50px;
  z-index: 999;
  background-color: #f6f7fb;
}
// 筛选框
.filter-date {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 15px 0 10px;
  .filter-left {
    .date {
      font-size: 20px;
      font-weight: 600;
      color: #555;
      display: flex;
      align-items: center;
      img {
        width: 10px;
        height: 7px;
        margin-left: 10px;
      }
    }
    .appeal {
      font-size: 12px;
      color: #7f7f7f;
      margin-top: 5px;
    }
  }
  .filter-right {
    display: flex;
    align-items: center;
    justify-self: space-around;
    div:first-child {
      margin-right: 10px;
    }
  }
  .filter {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 15px;
      height: 15px;
    }
  }
  .filter-non {
    background: #fff;
  }
  .filter-active {
    background: #5cc0eb;
  }
}

// 列表
.list {
  padding: 0 15px;
  padding-top: 100px;
  padding-bottom: 50px;
  // 卡片信息
  .info {
    width: 100%;
    min-height: 152px;
    font-size: 12px;
    color: #4e7092;
    background: #fff;
    border-radius: 8px;
    padding: 10px 3px;
    padding-bottom: 0;
    margin-bottom: 15px;
    // 标题
    &-title {
      padding-left: 10px;
      padding-right: 20px;
      .content {
        font-size: 15px;
        font-weight: 600;
      }
      .date {
        font-size: 14px;
        color: #4e7092;
        opacity: 0.5;
        border-radius: 6px;
        text-align: center;
        line-height: 24px;
      }
    }
    // 信息类型
    &-type {
      display: flex;
      align-items: center;
      padding-left: 10px;
    }
    // 内容信息
    &-content {
      width: 100%;
      margin-top: 5px;
      padding: 0 17px 12px 13px;
      border-bottom: 1px solid #f2f2f2;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      div {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .info-data {
        width: 50%;
        margin-bottom: 3px;
        div:first-child {
          width: 60%;
          font-weight: 600;
        }
        div:last-child {
          width: 40%;
          justify-content: center;
        }
      }
    }
    // 查看详情
    &-bottom {
      height: 40px;
      color: #02a7f0;
      padding: 0 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .detail {
        color: #4e7092;
        height: 100%;
        line-height: 40px;
      }
      .info-appeal {
        display: flex;
        align-items: center;
        .appeal-tips {
          margin-right: 10px;
          color: #fe3a2f;
        }
      }
      .appeal {
        width: 60px;
        height: 26px;

        border-radius: 37px;
        line-height: 26px;
        text-align: center;
      }
      .appeal-edit {
        color: #fff;
        background: #6fc3ff;
      }
      .appeal-modify {
        color: #4e7091;
        background: #d6d6d6;
      }
    }
  }
}
.total {
  width: 100%;
  height: 50px;
  background: #f6f7fb;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  position: fixed;
  bottom: 0;
  padding-top: 5px;
  padding-bottom: 5px;
  &-item {
    width: 50%;
    display: flex;
    align-items: center;
    color: #969799;
    div {
      width: 60%;
    }
    div:last-child {
      width: 40%;
      text-align: right;
      margin-right: 30px;
    }
  }
}

// 筛选框
.filter-box {
  margin-top: 65px;
  padding: 0 25px;
  padding-bottom: 80px;
}
.filter-title {
  width: 100%;
  height: 50px;
  color: #555;
  background: #fff;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  padding: 17px;
  z-index: 9999;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
  border-bottom: 1px solid #f2f2f2;
  img {
    width: 14px;
    height: 14px;
  }
}
.input-title {
  font-size: 12px;
  color: #4e7092;
  margin-bottom: 10px;
}
.filter-input {
  width: 100%;
  height: 40px;
  font-size: 12px;
  border: 1px solid #aaa;
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.input-icon {
  display: flex;
  align-items: center;
}
.filter-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  left: 0;
  bottom: 0;
  padding: 10px 20px;
  background-color: #fff;
  // margin-top: 28px;
  .btn {
    width: 140px;
    height: 43px;
    font-size: 13px;
    color: #4e7092;
    border-radius: 16px;
    background: #f2f2f2;
    line-height: 43px;
  }
  .van-button--info {
    background-color: #6fc3ff;
    color: #fff;
    border: none;
  }
}
</style>
